module.exports = __webpack_public_path__ + "static/media/12_dominion-new_westminster.38b900e3.jpg";